import React, { Children, CSSProperties, useMemo, ReactNode } from 'react';
import css from './index.less'

export default ({ title = '暂未选择卡片，请从右侧面板添加卡片' }) => {
  return (
    <div className={css.emptySlot}>
      {title}
    </div>
  )
}